import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExamPropertiesTabNames } from './enums/properties-tab-names';

@Injectable({
  providedIn: 'root'
})
export class ExamSettingsTabService {

  private lastExamTab: number;
  private propTabs: ExamPropertiesTabNames[] = [
    ExamPropertiesTabNames.Document,
    ExamPropertiesTabNames.Users,
    ExamPropertiesTabNames.Features,
    ExamPropertiesTabNames.Time,
    ExamPropertiesTabNames.Cloud
  ];
  private tabObservable: BehaviorSubject<number>;

  constructor() {
    this.lastExamTab = 0;
    this.tabObservable = new BehaviorSubject(this.lastExamTab);
  }

  get getTabChangedObservable(): Observable<number> {
    return this.tabObservable.asObservable();
  }

  get propertyTabs() : ExamPropertiesTabNames[] {
    return this.propTabs;
  }

  get getLastTab(): number {
    return this.lastExamTab;
  }

  setLastTab(value: number, whenOpening: boolean = false) {
    if (this.lastExamTab !== value || whenOpening) {
      this.lastExamTab = value;
      this.tabObservable.next(value);
    }
  }

  reset() {
    this.lastExamTab = 0;
    this.tabObservable.next(0);
  }
}
